import { useEffect, useCallback } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'sonner';

const UPDATE_CHECK_INTERVAL = 15 * 60 * 1000; // 15 minutes

export function useRegisterPWA(): void {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      // One-time cleanup: o OneSignal SDK antigo registrava OneSignalSDKWorker.js
      // no mesmo scope `/` do sw.js, virando "waiting" eterno (não responde a
      // SKIP_WAITING) e causando o toast "Nova versão disponível" voltar após
      // todo reload. Detectamos esse estado e desregistramos pra limpar — após
      // o reload, o OneSignal vai registrar em scope dedicado (/push/onesignal/).
      if (registration.waiting?.scriptURL.includes('OneSignalSDKWorker')) {
        void registration.unregister().then(() => window.location.reload());
        return;
      }

      // Periodic check for new SW versions
      setInterval(() => {
        registration.update();
      }, UPDATE_CHECK_INTERVAL);
    },
    onRegisterError(error) {
      console.error('[PWA] Service worker registration failed:', error);
    },
  });

  const handleUpdate = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  const handleDismiss = useCallback(() => {
    setNeedRefresh(false);
  }, [setNeedRefresh]);

  useEffect(() => {
    if (!needRefresh) return;

    toast.custom(
      (id) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: '#ffffff',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            fontSize: '13px',
            color: '#334155',
            border: '1px solid #e2e8f0',
          }}
        >
          <span style={{ flex: 1 }}>Nova versão disponível</span>
          <button
            onClick={() => { toast.dismiss(id); handleDismiss(); }}
            style={{
              background: 'none',
              border: 'none',
              color: '#64748b',
              cursor: 'pointer',
              fontSize: '13px',
              padding: '4px 8px',
            }}
          >
            Depois
          </button>
          <button
            onClick={() => { toast.dismiss(id); handleUpdate(); }}
            style={{
              background: '#8b5cf6',
              color: '#ffffff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
              padding: '6px 16px',
            }}
          >
            Atualizar
          </button>
        </div>
      ),
      { duration: Infinity, id: 'pwa-update' }
    );
  }, [needRefresh, handleUpdate, handleDismiss]);
}
